import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from 'api/rtk-api'
import { PercentageSunburstWithTable, PercentageSunburstWithTableLoading } from 'components/core-v2'
import { useParams } from 'react-router-dom'

import { TENANT } from '@/const'

import { getFormattedChartData } from './getFormattedChartData'
import classes from './portfolio-assets-breakdown.module.scss'

export const PortfolioAssetsBreakdown = () => {
  const { source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading)
    return (
      <div className={classes.root}>
        <div className={classes.chartWrapper}>
          <h2>Tax classification</h2>
          <PercentageSunburstWithTableLoading rowCount={2} />
        </div>
        <div className={classes.chartWrapper}>
          <h2>Class</h2>
          <PercentageSunburstWithTableLoading rowCount={2} />
        </div>
        <div className={classes.chartWrapper}>
          <h2>Currency</h2>
          <PercentageSunburstWithTableLoading rowCount={2} />
        </div>
        <div className={classes.chartWrapper}>
          <h2>Trading frequency</h2>
          <PercentageSunburstWithTableLoading rowCount={2} />
        </div>
      </div>
    )

  const formattedData = getFormattedChartData(data)

  return (
    <div className={classes.root}>
      <div className={classes.chartWrapper}>
        <h2>Tax classification</h2>
        <PercentageSunburstWithTable
          data={formattedData.taxClassification}
          seriesName="Tax classification"
        />
      </div>
      <div className={classes.chartWrapper}>
        <h2>Class</h2>
        <PercentageSunburstWithTable data={formattedData.assetClass} seriesName="Class" />
      </div>
      <div className={classes.chartWrapper}>
        <h2>Currency</h2>
        <PercentageSunburstWithTable data={formattedData.currency} seriesName="Currency" />
      </div>
      <div className={classes.chartWrapper}>
        <h2>Trading frequency</h2>
        <PercentageSunburstWithTable
          data={formattedData.tradingFrequency}
          seriesName="Trading frequency"
        />
      </div>
    </div>
  )
}
